module.exports = __webpack_public_path__ + "img/Old_Mall.c95d52ea.png";